(function() {
  'use strict';

  angular
    .module('media.mediaControlsDirective', ['factories.mobileHelper'])
    .directive('mfMediaControls', mfMediaControls);

  mfMediaControls.$inject = ['$timeout', 'PlayerControls', 'Navigation', 'MobileHelper', '$rootScope', 'Sension', '$window'];

  function mfMediaControls($timeout, PlayerControls, Navigation, MobileHelper, $rootScope, Sension, $window) {
    var isTouch = ("ontouchstart" in document.documentElement);
    var events = isTouch
      ? { touchstart: 'touchstart', touchend: 'touchend', touchmove: 'touchmove' }
      : { touchstart: 'mousedown', touchend: 'mouseup', touchmove: 'mousemove' };

    return function(scope, elem, attr) {
      var mediaPollTimer;
      var duration;
      var currentTime = 0;
      var bufferedPercent = 0;
      var scrubTrack = elem.find('.mediaControlsScrubber');
      var scrubBarProgress = elem.find('.mediaScrubBarProgressBG');
      var scrubBarBuffered = elem.find('.mediaScrubBarBufferedBG');
      var scrubThumb = elem.find('.mediaScrubThumb');
      var noFFtimeout;

      //The scrub bar is longer than the track since it sits behind and has to fill in the rounded edges
      var scrubBarWidth = 0;

      var mediaState = null;
      var mediaControl = null;
      var states;

      scope.$watch('mediaControl', function(newMediaControl) {
        if (!newMediaControl || mediaControl === newMediaControl) return;
        mediaControl = newMediaControl;
      });

      var dereg = $rootScope.$watch('canMute', function(canMute) {
        scope.canMute = canMute;

        // If value changed then change the control sizes after the DOM changes.
        setTimeout(scope.setControlsSizes);
      });

      scope.playerControls = PlayerControls;

      scope.setControlsSizes = function() {
        scrubBarWidth = parseInt(scrubTrack.width());
        scope.setScrubber();
      };

      scope.$watch('mediaState', function(newMediaState) {
        if (!newMediaState) return;

        mediaState = newMediaState;
        states = mediaState.states;

        scope.setControlsSizes();
      });

      scrubTrack.hammer()
        .on('dragstart', onScrubberTouchStart)
        .on('drag', onScrubberTouchMove)
        .on('dragend', onScrubberTouchEnd)
        .on('tap', onTap);

      angular.element($window).on(events.touchend, onScrubberTouchEnd);
      angular.element($window).on('resize', scope.setControlsSizes);

      var timeBeforeFastForward;

      function timeUpdate() {
        currentTime = scope.getProcessedCurrentTime();
        duration = mediaControl.getDuration();
        mediaState.duration = Math.round(duration);
        bufferedPercent = mediaControl.getBufferedPercent();
        if (MobileHelper.isIOS() && !scope.cModule.allowFastForward
          && mediaControl.trackProgress === true) {
          if (currentTime > timeBeforeFastForward + 1) {
            mediaControl.rawSeek(timeBeforeFastForward);
            return;
          }
        }

        if (!duration || !mediaControl.haveEnoughData()) return;

        if (mediaState.state != states.scrubbing && (scope.atClickPoint() || scope.atEnd()))
          $timeout(mediaControl.pause);

        scope.setScrubber();
        timeBeforeFastForward = currentTime;
      }


      scope.setScrubber = function() {
        if (!mediaState)
          return;

        scrubBarWidth = parseInt(scrubTrack.width());
        var percent = duration ? currentTime / duration : 0;
        percent = Math.max(0, Math.min(1, percent));

        var progressWidth = parseInt(percent * scrubBarWidth);
        scrubBarProgress.css({ width: progressWidth + 'px' });

        var bufferedWidth = parseInt(bufferedPercent * scrubBarWidth);
        scrubBarBuffered.css({ width: bufferedWidth + 'px' });

        if (mediaState.state !== states.scrubbing) {
          setScrubThumb(percent);
        }
      };

      function setScrubThumb(percent) {
        percent = Math.max(0, Math.min(1, percent));

        var thumbLeft = Math.max(12, (percent * scrubBarWidth));
        scrubThumb.css({ left: thumbLeft + 'px' });

        var time = Math.round(percent * duration);
        if (mediaState.currentTime !== time) {
          $timeout(function() {
            mediaState.currentTime = time;
          });
        }
      }

      var prevState;
      var scrubPercent;

      function onTap(e) {
        onScrubberTouchStart(e);
        onScrubberTouchMove(e);
        onScrubberTouchEnd();
      }

      function onScrubberTouchStart(e) {
        elem.removeClass('mediaPlaying');

        if (mediaState.state == states.ended)
          prevState = states.paused;
        else
          prevState = mediaState.state;
        mediaState.state = states.scrubbing;
        onScrubberTouchMove(e);
      }

      function onScrubberTouchEnd() {
        if (!mediaState) return;
        if (mediaState.state != states.scrubbing) return;

        var time = scrubPercent * duration;
        mediaControl.seek(time);

        mediaState.state = prevState;
      }

      function onScrubberTouchMove(e) {
        if (mediaState.state != states.scrubbing) return;

        PlayerControls.resetControlsTimer();

        var x = e.gesture.center.pageX;
        mediaControl.slide.progressSeconds = Math.max(mediaControl.slide.progressSeconds, Math.floor(mediaControl.getCurrentTime()));

        var scrubOffsetX = scrubTrack.offset().left;
        scrubPercent = (x - scrubOffsetX) / scrubBarWidth;
        if (mediaControl.trackProgress
          && (Sension.requireEngagement() || !scope.cModule.allowFastForward)
          && Navigation.slideIndex == (Navigation.numUnlockedSlides - 1)) {

          if (scrubPercent > (mediaControl.slide.progressSeconds / duration)) {
            mediaState.showNoFastForwardNotification = true;
            clearTimeout(noFFtimeout);
            noFFtimeout = setTimeout(function() {
              mediaState.showNoFastForwardNotification = false;
            }, 3000);
          }
          scrubPercent = Math.min(scrubPercent, (mediaControl.slide.progressSeconds / duration));
        }
        setScrubThumb(scrubPercent);
      }

      scope.onPlaying = function() {
        elem.addClass('mediaPlaying');
        if (!mediaPollTimer)
          mediaPollTimer = setInterval(timeUpdate, 50);
      };

      scope.onPaused = function() {
        elem.removeClass('mediaPlaying');
      };

      scope.updateDirectiveCurrentTime = function(time) {
        currentTime = time;
      };

      scope.getDirectiveCurrentTime = function() {
        return currentTime;
      };

      scope.getDirectiveDuration = function() {
        return duration;
      };

      scope.$on('$destroy', function() {
        clearInterval(mediaPollTimer);
        scrubTrack.off();

        dereg();
      });
    }
  }
})();
